import BitPayButton from './BitPayButton';

export default BitPayButton;
